module.exports = {
  'about': 'О сайте',
  'for_helpers': 'Помощникам',
  'menu': 'Меню',
  'history': 'История',
  'search_word': 'Искать слово...',
  'n_i_ashmarin': 'Н.И. Ашмарин',
  'chuvash_dictionary': 'Словарь чувашского языка',
  'articles_on_site': 'Словарных статей на сайте',
  'last_added_articles': 'Последние добавленные статьи',
  'haval_org': 'Чувашская общественная организация "Хавал"',
  'more_text': 'Далее...'
}


// WEBPACK FOOTER //
// ./src/lang/ru/messages.js